<div class="custom-dialog figma-dialog">
  
  <div class="dialog-header flex-row-between">
    <div class="title">
      <h3 class="title-text">The following profiles could not be uploaded</h3>
      <p class="sub-title">
        {{failedCount}} out of {{totalRecords}} profiles were not uploaded.
        <a class="download-link" [class.is-disabled]="!failedUsers?.length"
           (click)="failedUsers?.length && downloadExcel()">Download Report</a>
      </p>
    </div>
    <div class="header-right-actions">
      <button mat-icon-button class="close-btn" aria-label="close button" (click)="closeDialog()">
        <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="custom-dialog__description">
      <div class="section-table data-listing text-left" *ngIf="!!failedUsers?.length">
        <table class="mat-mdc-table w-100 figma-table">
            <thead role="rowgroup" class="mat-mdc-header-row mdc-data-table__header-row cdk-header-row">
                <tr>
                  <th class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell">{{content?.['b2b.managetraveler.employcode'] || 'Employee Code'}}</th>
                  <th class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell">{{content?.['b2b.managetraveler.employname'] || 'Employee Name'}}</th>
                  <th class="mat-mdc-header-cell mdc-data-table__header-cell cdk-header-cell">{{companyManagementContent?.['b2b.managecompany.omfemployemail'] || 'Employee Email'}}</th>
                </tr>
            </thead>
            <tbody role="rowgroup" class="mdc-data-table__content">
                <tr class="mat-mdc-row mdc-data-table__row cdk-row" *ngFor="let user of displayData">
                    <td class="mat-mdc-cell mdc-data-table__cell cdk-cell">{{user?.EmployeeCode}}</td>
                    <td class="mat-mdc-cell mdc-data-table__cell cdk-cell">{{user?.UserName}}</td>
                    <td class="mat-mdc-cell mdc-data-table__cell cdk-cell">{{user?.Email}}</td>
                </tr>
            </tbody>
        </table>
      </div>
    </div>
  </mat-dialog-content>

  <div class="f-col verify-footer dialog-footer" *ngIf="hasMoreData()">
      <button mat-button class="button--secondary-small" (click)="loadMore()">{{content?.['b2b.managetraveler.loadmore'] || 'Load more'}}</button>
  </div>

</div>
